import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import AllPostsPagination from "./AllPostsPagination";
import useStore from "@/hooks/useStore";
import PostCardGrid from "@/components/utils/PostCardGrid/PostCardGrid";
import Filter from "@/components/utils/Filter/Filter";
import NoPosts from "@/components/utils/NoPosts/NoPosts";
import { ALL_CATEGORY } from "@/utils/appConstants";
import { AllPostsPropTypes } from "./propTypes";
import "./styles.scss";

/* #META
 {
  "NAME": "AllPosts",
  "CLASSNAME": "posts",
  "URL": "http://nicasource.local/insights"
 }
#ENDMETA */

const AllPosts = ({ data }) => {
  const { posts_per_page: postsPerPage = 12, posts_type: postsType } = data;

  const { getItems, requestedItems, getTotalPages } = useStore();

  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [posts, setPosts] = useState();
  const [selectedCategory, setSelectedCategory] = useState(ALL_CATEGORY);
  const postsSectionRef = useRef(null);

  const postsRequest = {
    type: postsType,
    params: {
      _embed: 1,
      page,
      per_page: Number(postsPerPage),
    },
    showLoading: true,
  };

  useEffect(() => {
    getCategories().then((res) => {
      const prepareCats = res
        .map((el) => {
          return { name: el.id.toString(), title: el.name };
        })
        .sort((a, b) => a.title.localeCompare(b.title));

      prepareCats.unshift({ name: ALL_CATEGORY, title: "All" });

      setCategories(prepareCats);
    });
  }, []);

  useEffect(() => {
    getPosts();
  }, [page, selectedCategory]);

  const getPosts = () => {
    postsRequest.params.page = page;
    postsRequest.params.categories = selectedCategory;

    if (selectedCategory === ALL_CATEGORY) {
      delete postsRequest.params.categories;
    }

    async function fetchData() {
      await getItems(postsRequest);
      setPosts(requestedItems(postsRequest));
      setPages(getTotalPages(postsRequest));
    }

    fetchData();
  };

  const getCategories = () => {
    const catRequest = {
      type: "categories",
      params: {
        per_page: 25,
      },
    };

    async function fetchCategories() {
      await getItems(catRequest);
      return requestedItems(catRequest);
    }

    return fetchCategories();
  };

  const onPageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pages && newPage != page) {
      setPage(newPage);
      getPosts();
    }
  };

  const onCategoryChange = (newCategory) => {
    if (selectedCategory != newCategory) {
      setPage(1);
      setSelectedCategory(newCategory);
      getPosts();
    }
  };

  const getCategoryName = () => {
    let categoryName = "";
    categories.forEach((item) => {
      if (item.name == selectedCategory) categoryName = item.title;
    });
    return categoryName;
  };

  return (
    <section className="posts component-module" ref={postsSectionRef}>
      <div className="container-revamp xl:px-0">
        {(posts?.length > 0 || (posts?.length == 0 && selectedCategory !== ALL_CATEGORY)) && (
          <div className="posts-filter">
            <Filter
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={onCategoryChange}
            />
          </div>
        )}

        <div className="posts-items">
          {posts?.length ? (
            <>
              <PostCardGrid posts={posts} entryType={postsType} />
              <AllPostsPagination page={page} pages={pages} changePage={onPageChange} />
            </>
          ) : (
            <NoPosts postType={postsType} category={getCategoryName()} />
          )}
        </div>
      </div>
    </section>
  );
};

AllPosts.propTypes = AllPostsPropTypes;

export default AllPosts;
